import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { getImageUrl } from "src/utils/imageUrl";

const GlobalSEO = () => {
  const globalData = useSelector((state) => state.globalData.globalDataName);
  const location = useLocation();

  // Get API response data
  const businessName = globalData?.businessName;
  const businessDescription = globalData?.description;

  // Build logo/image URL from API data
  let ogImage = null;
  if (globalData?.logoUrl) {
    ogImage = getImageUrl(globalData.logoUrl);
  }

  const canonicalUrl = `${window.location.origin}${location.pathname}`;

  // Update document head directly for better social media crawler support
  useEffect(() => {
    if (businessName) {
      // Update title
      document.title = businessName;
      const titleMeta = document.querySelector('#seo-title');
      if (titleMeta) titleMeta.textContent = businessName;

      // Update og:title
      const ogTitleMeta = document.querySelector('meta[property="og:title"]');
      if (ogTitleMeta) ogTitleMeta.setAttribute('content', businessName);

      // Update twitter:title
      const twitterTitleMeta = document.querySelector('meta[name="twitter:title"]');
      if (twitterTitleMeta) twitterTitleMeta.setAttribute('content', businessName);
    }

    if (businessDescription) {
      // Update description
      const descMeta = document.querySelector('meta[name="description"]');
      if (descMeta) descMeta.setAttribute('content', businessDescription);
      const seoDescMeta = document.querySelector('#seo-description');
      if (seoDescMeta) seoDescMeta.setAttribute('content', businessDescription);

      // Update og:description
      const ogDescMeta = document.querySelector('meta[property="og:description"]');
      if (ogDescMeta) ogDescMeta.setAttribute('content', businessDescription);

      // Update twitter:description
      const twitterDescMeta = document.querySelector('meta[name="twitter:description"]');
      if (twitterDescMeta) twitterDescMeta.setAttribute('content', businessDescription);
    }

    if (ogImage) {
      // Update og:image
      const ogImageMeta = document.querySelector('meta[property="og:image"]');
      if (ogImageMeta) ogImageMeta.setAttribute('content', ogImage);

      // Update twitter:image
      const twitterImageMeta = document.querySelector('meta[name="twitter:image"]');
      if (twitterImageMeta) twitterImageMeta.setAttribute('content', ogImage);
    }

    // Update og:url
    const ogUrlMeta = document.querySelector('meta[property="og:url"]');
    if (ogUrlMeta) ogUrlMeta.setAttribute('content', canonicalUrl);

  }, [businessName, businessDescription, ogImage, canonicalUrl]);

  // Always render Helmet for React management
  return (
    <Helmet>
      {/* Dynamic Open Graph Tags - from API response */}
      <meta property="og:type" content="website" />
      {businessName && <meta property="og:title" content={businessName} />}
      {businessDescription && <meta property="og:description" content={businessDescription} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogImage && <meta property="og:image:width" content="1200" />}
      {ogImage && <meta property="og:image:height" content="630" />}
      <meta property="og:url" content={canonicalUrl} />
      {businessName && <meta property="og:site_name" content={businessName} />}

      {/* Twitter Card Tags - from API response */}
      <meta name="twitter:card" content="summary_large_image" />
      {businessName && <meta name="twitter:title" content={businessName} />}
      {businessDescription && <meta name="twitter:description" content={businessDescription} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {/* General Meta Tags - from API response */}
      {businessDescription && <meta name="description" content={businessDescription} />}
      {businessName && <meta name="author" content={businessName} />}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default GlobalSEO;
